/**
 * Production Guard
 * Disables console logs and protects against console access in production
 * Automatically activates when not running on localhost
 */ (function() {
    'use strict';
    // Check if we're in production (not localhost or beta)
    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1' && !window.location.hostname.includes('beta-dot-thinqbits');
    if (!isProduction) {
        console.log('%c[Production Guard] Running in development mode - protection disabled', 'color: #10b981; font-weight: bold;');
        return;
    }
    // =================================================================
    // PART 1: Disable Console Methods
    // =================================================================
    // Store original console methods (in case needed for critical errors)
    const _console = {
        log: console.log,
        warn: console.warn,
        error: console.error,
        info: console.info,
        debug: console.debug,
        table: console.table,
        trace: console.trace,
        dir: console.dir,
        group: console.group,
        groupCollapsed: console.groupCollapsed,
        groupEnd: console.groupEnd
    };
    // Override console methods with no-ops
    console.log = ()=>{};
    console.warn = ()=>{};
    console.info = ()=>{};
    console.debug = ()=>{};
    console.table = ()=>{};
    console.trace = ()=>{};
    console.dir = ()=>{};
    console.group = ()=>{};
    console.groupCollapsed = ()=>{};
    console.groupEnd = ()=>{};
    // Keep console.error for critical debugging
    console.error = _console.error;
    // =================================================================
    // PART 2: DevTools Detection
    // =================================================================
    let devtoolsOpen = false;
    const threshold = 160; // Size threshold for DevTools detection
    // Detect DevTools using timing-based approach
    function detectDevTools() {
        const widthThreshold = window.outerWidth - window.innerWidth > threshold;
        const heightThreshold = window.outerHeight - window.innerHeight > threshold;
        if (widthThreshold || heightThreshold) {
            if (!devtoolsOpen) {
                devtoolsOpen = true;
                handleDevToolsOpen();
            }
        } else devtoolsOpen = false;
    }
    // Alternative detection method using console.log timing
    function detectDevToolsByTiming() {
        const start = performance.now();
        // This debugger statement causes delay when DevTools is open
        // eslint-disable-next-line no-debugger
        debugger;
        const end = performance.now();
        if (end - start > 100) {
            if (!devtoolsOpen) {
                devtoolsOpen = true;
                handleDevToolsOpen();
            }
        }
    }
    function handleDevToolsOpen() {
        // Option 1: Clear console periodically
        if (console.clear) console.clear();
    // Option 2: Show warning message (uncomment if desired)
    // alert('Developer tools detected. This application is protected.');
    // Option 3: Redirect to home page (uncomment if desired)
    // window.location.href = '/';
    // Option 4: Blank the page (uncomment if desired)
    // document.body.innerHTML = '<h1>Access Denied</h1>';
    }
    // Run detection periodically
    setInterval(detectDevTools, 1000);
    // Run timing-based detection less frequently (more intrusive)
    // setInterval(detectDevToolsByTiming, 5000);
    // =================================================================
    // PART 3: Disable Keyboard Shortcuts
    // =================================================================
    document.addEventListener('keydown', function(e) {
        // F12 - Developer Tools
        if (e.keyCode === 123) {
            e.preventDefault();
            return false;
        }
        // Ctrl+Shift+I - Developer Tools
        if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
            e.preventDefault();
            return false;
        }
        // Ctrl+Shift+J - Console
        if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
            e.preventDefault();
            return false;
        }
        // Ctrl+Shift+C - Inspect Element
        if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
            e.preventDefault();
            return false;
        }
        // Ctrl+U - View Source
        if (e.ctrlKey && e.keyCode === 85) {
            e.preventDefault();
            return false;
        }
        // Cmd+Option+I (Mac) - Developer Tools
        if (e.metaKey && e.altKey && e.keyCode === 73) {
            e.preventDefault();
            return false;
        }
        // Cmd+Option+J (Mac) - Console
        if (e.metaKey && e.altKey && e.keyCode === 74) {
            e.preventDefault();
            return false;
        }
        // Cmd+Option+C (Mac) - Inspect Element
        if (e.metaKey && e.altKey && e.keyCode === 67) {
            e.preventDefault();
            return false;
        }
    });
    // =================================================================
    // PART 4: Disable Right-Click Context Menu
    // =================================================================
    document.addEventListener('contextmenu', function(e) {
        e.preventDefault();
        return false;
    });
    // =================================================================
    // PART 5: Disable Text Selection (Optional - may impact UX)
    // =================================================================
    // Uncomment if you want to prevent text selection
    /*
    document.addEventListener('selectstart', function(e) {
        e.preventDefault();
        return false;
    });
    */ // =================================================================
    // PART 6: Clear Console Periodically
    // =================================================================
    setInterval(function() {
        if (console.clear) console.clear();
    }, 5000); // Clear every 5 seconds
    // =================================================================
    // PART 7: Prevent Common Console Access Patterns
    // =================================================================
    // Detect and block access to window.__REACT_DEVTOOLS_GLOBAL_HOOK__
    Object.defineProperty(window, '__REACT_DEVTOOLS_GLOBAL_HOOK__', {
        get: function() {
            throw new Error('React DevTools not available');
        }
    });
    // Block common debugging variables
    Object.defineProperty(window, 'angular', {
        get: function() {
            throw new Error('Not available');
        }
    });
    // =================================================================
    // PART 8: Anti-Debugging Techniques
    // =================================================================
    // Infinite debugger loop (very aggressive - use carefully)
    // Uncomment only if you want maximum protection
    /*
    setInterval(function() {
        // eslint-disable-next-line no-debugger
        debugger;
    }, 50);
    */ // Make it harder to stop the protection
    Object.freeze(console);
})();

//# sourceMappingURL=app.5506dc85.js.map
